/*
 * Copyright (c) Worldline 2023.
 */

export const ExternalEvidencePartStatus = {
    toUpload: 'TO_UPLOAD',
    inProgress: 'IN_PROGRESS',
    completed: 'COMPLETED',
    error: 'ERROR'
}